export default class CatchUpAsset {
  constructor(obj) {
    this.items = []

    if (obj && obj.length > 0) {
      this.items = obj
    }
  }
}
